export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5361.d66b8d5c.jpg";